import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumbs, Breadcrumb } from 'legacy/components/Breadcrumbs'
import withRetailerRouter from 'legacy/common/withRouter'

const RequestNewProductBreadcrumbs = () => (
  <Breadcrumbs>
    <Breadcrumb>
      <FormattedMessage id="catalog.addProducts.title" />
    </Breadcrumb>
    <Breadcrumb>
      <FormattedMessage id="catalog.product.requestNew.title" />
    </Breadcrumb>
  </Breadcrumbs>
)

export default withRetailerRouter(RequestNewProductBreadcrumbs)
